<template>
  <div id="app">
    <navbar />
        <!-- <div class="global-row">
        </div> -->
      <div class="global-table">
        <div class="global-row expand">
          <div class="sidenav-table">
            <div class="table-row">
              <div class="table-cell sidenav-cell">
                <SideNav />
              </div>
              <div class="table-cell v-center content-container">
                <router-view v-if="$store.state.location !== null" />
                <LocationSelect v-else />
                <!-- <font-awesome-layers class="fa-5x" v-else>
                  <font-awesome-icon :icon="['fal', 'server']" transform="shrink-8" />
                  <font-awesome-icon v-if="pending" :icon="['fal', 'circle-notch']" spin />
                </font-awesome-layers> -->
              </div>
            </div>
          </div>
        </div>
        <div class="global-row">
          <Footer />
        </div>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import navbar from '@/components/navbar'
import SideNav from '@/components/SideNav'
import Footer from '@/components/Footer'
import LocationSelect from '@/components/LocationSelect'

export default {
  name: 'App',
  components: { navbar, SideNav, Footer, LocationSelect },
  computed: {
    ...mapState(['domain', 'location', 'locations']),
  },
  mounted() {
    this.$store.commit('locations', this.$directus.locations.fetch())
    let locationSlug = this.getLocationSlugFromHostname()
    if (locationSlug) {
      this.$store.commit('location', new Promise((resolve, reject) => {
        this.locations.then(locations => {
          let location = locations.find(l => l.slug === locationSlug)
          if (location) {
            resolve(location)
            document.title = document.title + ' ' + location.name
          } else {
            reject('no location with slug "' + locationSlug + '" found')
          }
        }, reject)
      }))
    }
  },
  methods: {
    getLocationSlugFromHostname() {
      let hostname = window.location.hostname
      if (hostname === 'localhost') return 'offenburg'
      if (hostname === this.domain || !hostname.includes(this.domain)) return null
      return window.location.hostname.replace('.' + this.domain, '')
    },
  },
}
</script>

<style lang="scss">
@import "@/style/global.scss";


.global-table {
    display: table;
    table-layout: fixed;
    height: 100%;
    width: 100%;
    max-width: $max-width;
    padding-top: $navbar-offset;
    background-color: rgba($background-color,.6);
    margin: 0 auto;

    @media (max-width: $media-s) {
      padding-top: $navbar-offset-mobile;
    }

    .global-row {
      display: table-row;
      height: 1px;
      &.expand {
        height:auto;
      }
    }
}

.content-container {
  font-weight: 400;
  @media (min-width: $media-m) {
    padding: 0 $spacing*1.5 $spacing*1.5 $spacing*1.5;
    font-size: 1rem;
  }
  @media (max-width: $media-s) {
    padding: 0 $spacing $spacing $spacing;
    font-size: .9rem;
  }
}

body {
  height: 100vh;
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  background-image: $background-image;
  background-attachment: fixed;
}

#app {
  height: 100%;
}

.sidenav-table {
  display: table;
  width: 100%;
  height: 100%;
  .sidenav-cell {
    width: 1px;
  }
}
.table-row {
  display: table-row;
}
.table-cell {
  display: table-cell;
}
.v-center {
  display: table-cell;
  vertical-align: middle;
  height: 100%;
}
</style>
